import api from '@/store/api/customer/activity'
import * as mutationTypes from './mutation-types'

const initialState = () => ({
    activity: {}
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        activity: state => state.activity
    },
    actions: {
        /**
         * @param {{customerId: number, activityId: number}} data
         * @returns {Promise<*>}
         */
        showActivity: async ({commit, dispatch}, data) => {
            try {
                const response = await api.showActivity(data)
                commit(mutationTypes.SET_ACTIVITY, response)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetActivity: async ({commit}) => commit(mutationTypes.RESET_ACTIVITY)
    },
    mutations: {
        [mutationTypes.SET_ACTIVITY]: (state, data) => state.activity = data,
        [mutationTypes.RESET_ACTIVITY]: (state) => Object.assign(state, initialState())
    }
}
